<ul class="category-option-list">
  <li
    class="category-option"
    [class.active]="activeCategory(categoryOption)"
    *ngFor="let categoryOption of categoryOptions">
    <button
      class="category-option-button focus-link"
      (click)="categoryChanged(categoryOption)"
      type="button"
      [attr.aria-pressed]="activeCategory(categoryOption)">
      <span class="category-option-text">{{
        categoryTranslationKey(categoryOption) | translate
      }}</span>
    </button>
  </li>
</ul>
